import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusShellLeft], campus-shell-left',
})
export class ShellLeftDirective {
  @HostBinding('class.ui-shell__left')
  hasShellLeftClass = true;
}
